<template>
  <v-client-table
    :data="facesImpactees"
    :columns="columns"
    :options="options">
    <template #dateDebutAff="{ row }">
      {{ func.formatDate(row.dateDebutAff) }}
    </template>
    <template #dateFinAff="{ row }">
      {{ func.formatDate(row.dateFinAff) }}
    </template>
    <template #adresse="{ row }">
      {{ func.adressFullStringGetter(row.adresse, true) }}
    </template>
    <template #codePostal="{ row }">
      {{ row.adresse.codePostal }}
    </template>
    <template #ville="{ row }">
      {{ row.adresse.ville }}
    </template>
    <template #typeModification="{ row }">
      {{ row.isDeleted ? $t('catalogue.popUpCheckFacesImpact.typeModification.suppression')
        : $t('catalogue.popUpCheckFacesImpact.typeModification.modification') }}
    </template>
  </v-client-table>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import formatDate from '@/services/general/formatDate';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';

export default {
  props: {
    facesImpactees: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      func: {
        formatDate,
        adressFullStringGetter,
      },
    };
  },
  computed: {
    columnsData() {
      return [
        { name: 'reference', sort: true },
        { name: 'format', sort: true },
        { name: 'materiel', sort: true },
        { name: 'adresse', sort: true },
        { name: 'codePostal', sort: true },
        { name: 'ville', sort: true },
        { name: 'dateDebutAff', sort: true },
        { name: 'dateFinAff', sort: true },
        { name: 'typeModification', sort: true },
      ];
    },
    columns() {
      return this.columnsData.map(e => e.name);
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      const headings = this.columnsData.reduce((acc, col) => {
        acc[col.name] = this.$t(`catalogue.popUpCheckFacesImpact.table.${col.name}`);
        return acc;
      }, {});
      const sortable = this.columnsData.filter(e => e.sort).map(e => e.name);
      return {
        sortIcon: SORT_ICON,
        headings,
        sortable,
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        customSorting: {
          adresse: (ascending) => {
            return (faceA, faceB) => {
              const adresseA = adressFullStringGetter(faceA.adresse, true);
              const adresseB = adressFullStringGetter(faceB.adresse, true);
              if (ascending) {
                return adresseA.localeCompare(adresseB);
              }
              return adresseB.localeCompare(adresseA);
            };
          },
          codePostal: (ascending) => {
            return (faceA, faceB) => {
              if (ascending) {
                return faceA.adresse.codePostal - faceB.adresse.codePostal;
              }
              return faceB.adresse.codePostal - faceA.adresse.codePostal;
            };
          },
          ville: (ascending) => {
            return (faceA, faceB) => {
              if (ascending) {
                return faceA.adresse.ville.localeCompare(faceB.adresse.ville);
              }
              return faceB.adresse.ville.localeCompare(faceA.adresse.ville);
            };
          },
        },
      };
    },
  },
};
</script>
